// import { audioBlock } from './blocks/AudioBlock';
// 
// export default function applyConfig(config) {
//   return [
//     audioBlock,
//     // ...other configurations
//   ].reduce((acc, apply) => apply(acc), config);
// }

import audioBlock from './components/Blocks/AudioBlock';
import './theme/AudioBlock.less';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['en'],
    defaultLanguage: 'en',
  };
  audioBlock(config);
  return config;
};

export default applyConfig;
